import React, { Component } from 'react';

import '../style/LoginForm.css';
import { isAuthTokenByPath } from '../actions/AuthMethods';
import logo_soymas from '../img/1x/logo_soymas.png'
import icon_user from '../img/1x/icon_user.png'
import icon_pass from '../img/1x/icon_pass.png'

class LoginForm extends Component {

    state = {
        username: '',
        password: '',
        status: '',
        errors: {}
    }

    async fetchLogin(username, password) {
        try {
            const response = await fetch(localStorage.getItem("api") + '/login/', {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
                body: JSON.stringify({
                    username: username,
                    password: password
                })
            })

            const data = await response.json();
            this.setState(data);

            // Si recibe el token, el loguin fue exitoso
            if (data.token) {
                localStorage.setItem('jwtToken', data.token);
            }
            if (localStorage.getItem('jwtToken')) {
                this.props.history.push("/");
                this.props.updateParent();
            }

        } catch (err) {
            console.log(err.toString())
            this.setState({ status: "Error en el servidor, prueba de nuevo" });
            return;
        }
    }


    handleSubmit = (e) => {
        e.preventDefault();
        this.fetchLogin(e.target.username.value, e.target.password.value)
    }

    componentDidMount() {
        if (isAuthTokenByPath(this.props.location)) {
            this.props.history.push("/");
        }

        // M.AutoInit();
    }

    render() {

        const { status, errors } = this.state;

        return (
            <div id="LoginForm">
                <div className="container">
                    <div className="row">
                        <div className="col s12 l8 title">
                            <h1>BIENVENIDO</h1>
                        </div>
                        <div className="col s12 l4">
                            {errors.form && <div>{errors.form}</div>}
                            <label >{status}</label>
                            <img className="responsive-img" src={logo_soymas} alt=""></img>
                            <form onSubmit={this.handleSubmit}>
                                <div className="row">
                                    <div className="col s2">
                                        <img src={icon_user} alt=""></img>
                                    </div>
                                    <div className="input-field col s10">
                                        <input id="username" name="username" type="text" className="validate" required />
                                        <label htmlFor="username">Nombre de usuario</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col s2">
                                        <img src={icon_pass} alt=""></img>
                                    </div>
                                    <div className="input-field col s10">
                                        <input id="password" name="password" type="password" className="validate" required />
                                        <label htmlFor="password">Contraseña</label>
                                    </div>
                                </div>

                                <div className="input-field col s12 l6 offset-l3">
                                    <input className="btn" id="submit" type="submit" value="Ingresar" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default LoginForm